import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBar from '~/components/dashboard/SearchBar';
import axios from '~/plugins/axios';

export default {
  name: 'PendingList',
  components: {
    SearchBar: SearchBar
  },
  data: function data() {
    return {
      needSearch: true,
      pendingRegUserFields: {
        fullName: {
          key: 'fullname',
          label: 'Name'
        },
        nricFin: {
          key: 'nricFin',
          label: 'Nric / Fin'
        },
        companyName: {
          key: 'companyName',
          label: 'companyName',
          sortable: true
        },
        flag: {
          key: 'flag',
          label: 'Acc. Type'
        },

        actions: {
          key: 'actions',
          label: 'Actions'
        }
      },
      currentPage: 1,
      perPage: 10,
      totalRows: this.$store.state.pendingAction.userPendingRegList.length,
      pendingRegUserInfo: [],

      fileListModal: {
        title: '',
        content: {
          nricFin: '',
          fileList: []
        }
      }
    };
  },
  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return axios.post('/users/pendingRegistration', null);

            case 2:
              this.pendingRegUserInfo = _context.sent.data;

              this.$store.commit('pendingAction/setUserPendingRegList', this.pendingRegUserInfo);
              console.log('\n\n ======== PendingList <|-- mounted ====== \n', this.pendingRegUserInfo, '\n -------------------');

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),

  methods: {
    getSearchResult: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
        var searchKey = _ref2.searchKey,
            searchContent = _ref2.searchContent;
        var userPendingRegList, nricFin, user, companyName, fullname;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('\n\n ======== from pending List - received data =======\n Search Key: ', searchKey, '\n Search Content :', searchContent, '\n ============');

                userPendingRegList = [];

                if (!(searchKey == 'Nric/Fin')) {
                  _context2.next = 14;
                  break;
                }

                console.log('NRIC FIN');
                nricFin = searchContent.trim();
                _context2.next = 7;
                return axios.post('/users/nricFinPendingReg', { nricFin: nricFin });

              case 7:
                user = _context2.sent.data;

                console.log('\n\n ========= from pending List - getSearchRes ========= \n', user, '\n -----------------------------');
                userPendingRegList.push(user);
                console.log('\n\n ========= from pending List - userPendingRegList ========= \n', userPendingRegList, '\n -----------------------------');
                this.pendingRegUserInfo = userPendingRegList[0] == 'User Not Found' || !userPendingRegList ? alert('User Not Found') : userPendingRegList;
                _context2.next = 35;
                break;

              case 14:
                if (!(searchKey == 'Company')) {
                  _context2.next = 24;
                  break;
                }

                console.log('Company');
                companyName = searchContent.trim();
                _context2.next = 19;
                return axios.post('/users/companyNamePendingReg', {
                  companyName: companyName
                });

              case 19:
                userPendingRegList = _context2.sent.data;

                console.log('\n\n ======== from pending List - getSearchRes ======== \n', userPendingRegList, '\n ---------------------------');
                this.pendingRegUserInfo = userPendingRegList[0] == 'User Not Found' || !userPendingRegList ? alert('User Not Found') : userPendingRegList;
                _context2.next = 35;
                break;

              case 24:
                if (!(searchKey == 'Full Name')) {
                  _context2.next = 34;
                  break;
                }

                console.log('Full Name');
                fullname = searchContent.trim();
                _context2.next = 29;
                return axios.post('/users/fullNamePendingReg', {
                  fullname: fullname
                });

              case 29:
                userPendingRegList = _context2.sent.data;

                console.log('\n\n ======== from pending List - getSearchRes ======== \n', userPendingRegList, '\n ---------------------------');
                this.pendingRegUserInfo = userPendingRegList[0] == 'User Not Found' || !userPendingRegList ? alert('User Not Found') : userPendingRegList;
                _context2.next = 35;
                break;

              case 34:
                alert('Error Search');

              case 35:
                this.$store.commit('pendingAction/setUserPendingRegList', this.pendingRegUserInfo);
                console.log('\n\n ========= from pending List - this.$store.userPendingRegList ========= \n', this.$store.state.pendingAction.userPendingRegList, '\n -----------------------------');

              case 37:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSearchResult(_x) {
        return _ref3.apply(this, arguments);
      }

      return getSearchResult;
    }(),
    approveUser: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item, index, button) {
        var user, isActivated, updateRegInfo;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('\n\n ======pendingList.vue key of approveUser items =========\n', item, '\n ======================');
                console.log('\n\n ======pendingList.vue key of approveUser key ===========\n', index, '\n ======================');
                console.log('\n\n =======pendingList.vue key of approveUser button ===========\n', button, '\n ======================');

                user = item;
                isActivated = true;
                _context3.next = 7;
                return axios.post('/users/updateRegistration', {
                  user: user,
                  isActivated: isActivated
                });

              case 7:
                updateRegInfo = _context3.sent.data;


                this.$store.commit('pendingAction/updatePendingRegUser', user);

                console.log('\n\n ========== Update Reg Info ========= \n', updateRegInfo, '\n ----------------------------');

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function approveUser(_x2, _x3, _x4) {
        return _ref4.apply(this, arguments);
      }

      return approveUser;
    }(),
    rejectUser: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(item, index, button) {
        var user, isActivated, updateRegInfo;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('\n\n ======pendingList.vue key of REJECTUser items =========\n', item, '\n ======================');
                console.log('\n\n ======pendingList.vue key of REJECTUser key ===========\n', index, '\n ======================');
                console.log('\n\n =======pendingList.vue key of REJECTUser button ===========\n', button, '\n ======================');

                user = item;
                isActivated = false;
                _context4.next = 7;
                return axios.post('/users/updateRegistration', {
                  user: user,
                  isActivated: isActivated
                });

              case 7:
                updateRegInfo = _context4.sent.data;


                this.$store.commit('pendingAction/updatePendingRegUser', user);

                console.log('\n\n ========== Update Reg Info ========= \n', updateRegInfo, '\n ----------------------------');

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function rejectUser(_x5, _x6, _x7) {
        return _ref5.apply(this, arguments);
      }

      return rejectUser;
    }(),
    popUpFileModal: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(item, index, button) {
        var managerId, manager;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('\n\n ======popUpFileModal.vue key of REJECTUser items =========\n', item, '\n ======================');
                console.log('\n\n ======popUpFileModal.vue key of REJECTUser key ===========\n', index, '\n ======================');
                console.log('\n\n =======popUpFileModal.vue key of REJECTUser button ===========\n', button, '\n ======================');

                managerId = 'userMsManager' + item.id;
                _context5.next = 6;
                return axios.post('/userMsManager/obtainSingleManager', { managerId: managerId });

              case 6:
                manager = _context5.sent.data.manager;


                console.log('\n\n ====== popUpFileModal.vue <|-- userManager ======= ', manager, '\n --------------------');

                this.fileListModal.content.nricFin = item.nricFin;
                this.fileListModal.title = item.companyName + ' - ' + item.fullname + ' - ' + item.nricFin;
                this.fileListModal.content.fileList = manager.internalTrainingFiles;

                console.log('\n\n ====== popUpFileModal.vue <|-- this.fileListModal.content.fileList  ======= \n', this.fileListModal.content.fileList, '\n ------------------------');

                this.$root.$emit('bv::show::modal', 'fileListModal', button);

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function popUpFileModal(_x8, _x9, _x10) {
        return _ref6.apply(this, arguments);
      }

      return popUpFileModal;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/pendingAction/PendingList.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/pendingAction/PendingList.vue
// module chunks = 1 4 5